// JSU Summer - Trip child theme entry
// Inherits parent jsu-summer styles; this file adds trip/winter-only behavior.
import "../css/src/main.scss";

// ---------------------------------------------------------------------------
// Header — fixed-scroll toggle (master parity: HeaderTrip.vue useHead script).
// ---------------------------------------------------------------------------
(function () {
  if (typeof document === "undefined") return;
  document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector(".site-header");
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 50) {
        header.classList.add("fixed-scroll");
      } else {
        header.classList.remove("fixed-scroll");
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  });
})();

// ---------------------------------------------------------------------------
// Frontpage modal popup — master parity (SharedModal + localStorage gate).
//   Opens once per browser; "fpSubscribe" key in localStorage marks dismiss.
//   Click outside (overlay) or close button closes.
// ---------------------------------------------------------------------------
(function () {
  if (typeof document === "undefined") return;
  document.addEventListener("DOMContentLoaded", function () {
    var modal = document.getElementById("fpSubscribeModal");
    if (!modal) return;

    var key = modal.getAttribute("data-storage-key") || "fpSubscribe";
    try {
      if (window.localStorage && window.localStorage.getItem(key) === "dismissed") {
        modal.parentNode && modal.parentNode.removeChild(modal);
        return;
      }
    } catch (e) {
      /* private mode / disabled storage — fall through */
    }

    modal.classList.add("is-open");
    document.body.classList.add("fp-modal-open");

    function closeModal() {
      modal.classList.remove("is-open");
      document.body.classList.remove("fp-modal-open");
      try {
        window.localStorage && window.localStorage.setItem(key, "dismissed");
      } catch (e) {}
      // Cleanup so subsequent navigations don't see a hidden but still-rendered node.
      setTimeout(function () {
        modal.parentNode && modal.parentNode.removeChild(modal);
      }, 250);
    }

    modal.addEventListener("click", function (e) {
      if (e.target.closest("[data-fp-modal-close]")) {
        e.preventDefault();
        closeModal();
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeModal();
    });
  });
})();

// ---------------------------------------------------------------------------
// Countdown — vanilla JS replacement for vue3-flip-countdown.
//   Reads ISO deadline from `.countdown[data-deadline]` and updates the
//   four `.flip-clock__piece[data-unit]` blocks every second.
// ---------------------------------------------------------------------------
(function () {
  if (typeof document === "undefined") return;
  document.addEventListener("DOMContentLoaded", function () {
    var nodes = document.querySelectorAll(".countdown[data-deadline]");
    if (!nodes.length) return;

    function pad(n) {
      n = n < 0 ? 0 : n;
      return n < 10 ? "0" + n : "" + n;
    }

    nodes.forEach(function (root) {
      var deadline = new Date(root.getAttribute("data-deadline")).getTime();
      if (!deadline || isNaN(deadline)) return;

      var pieces = root.querySelectorAll(".flip-clock__piece");
      function tick() {
        var diff = deadline - Date.now();
        if (diff < 0) diff = 0;

        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        var values = { days: d, hours: h, minutes: m, seconds: sec };

        pieces.forEach(function (p) {
          var unit = p.getAttribute("data-unit");
          var v = pad(values[unit] || 0);
          p.querySelectorAll("[data-fc]").forEach(function (slot) {
            if (slot.textContent !== v) slot.textContent = v;
          });
        });

        if (diff <= 0) {
          clearInterval(timer);
        }
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  });
})();
